import EN from './EN.json'
import ES from './ES.json'
import FR from './FR.json'
import DE from './DE.json'
import IT from './IT.json'
import PL from './PL.json'
import PT from './PT.json'
import RU from './RU.json'
export const Language = (lang) => {
    switch (lang) {
        case 'EN':
            return EN
        case 'ES':
            return ES
        case 'FR':
            return FR
        case 'DE':
            return DE
        case 'IT':
            return IT
        case 'PL':
            return PL
        case 'PT':
            return PT
        case 'RU':
            return RU
        default:
            return EN
    }
}